(function(window, document, $, undefined){



  $('main.container').on('click', 'article.block .quick-view-info', function(e) {
  // $('article.block .quick-view-info').click(function(e) {
    e.preventDefault();
    var panel = $(this).parent().find('.info');
    var content = $(this).parent().find('.content');
    var overlay = $(this).parent().find('.info-overlay');
    var panelHeight = panel.outerHeight();
    var panelWidth = panel.outerWidth();
    var icon = $(this).find('i');

    if(panel.hasClass('hidden')) {
      //show
      console.log('showing info panel');
      panel.removeClass('hidden');
      // TweenMax.to(overlay,0.5,{autoAlpha:1, ease:Power1.easeIn});
      
      //reset others
      var resetOthers = false;
      if(resetOthers) {
        TweenMax.to($('.info'),0.5,{css:{right:-panelWidth}, ease:Power4.easeOut, onComplete:function(){
        }});
        TweenMax.to($('.content'),0.5,{opacity:1, ease:Power1.easeOut, onComplete:function(){
        }});
        $('.quick-view-info i').removeClass('fa-times');
        $('.quick-view-info i').addClass('fa-info');
      }
      //end reset others


      // TweenMax.fromTo(panel,0.5,{css:{top:-panelHeight}},{css:{top:0},ease:Power3.easeOut});
        icon.removeClass('fa-info');
        icon.addClass('fa-times');
      TweenMax.fromTo(panel,0.5,{css:{right:-panelWidth}},{css:{right:0},ease:Power4.easeOut, onComplete:function(){
      }});
      
      //scale
      // TweenMax.fromTo(content,0.3,{scaleX:1,scaleY:1},{css:{scaleX:0.9,scaleY:0.9},ease:Power3.easeOut, onComplete:function(){
      // }});

      TweenMax.fromTo(content,0.5,{opacity:1},{opacity:0,ease:Power2.easeOut, onComplete:function(){
      }});

    } else {
      //hide
      console.log('hiding info panel');
      // TweenMax.to(overlay,0.5,{autoAlpha:0, ease:Power3.easeOut});

      // TweenMax.to(panel,0.5,{css:{top:-panelHeight}, ease:Power3.easeOut, onComplete:function(){
        icon.removeClass('fa-times');
        icon.addClass('fa-info');

      TweenMax.to(panel,0.5,{css:{right:-panelWidth}, ease:Power4.easeOut, onComplete:function(){
        panel.addClass('hidden');
      }});
      
      //scale
      // TweenMax.fromTo(content,0.3,{scaleX:0.9,scaleY:0.9},{css:{scaleX:1,scaleY:1},ease:Power3.easeOut, onComplete:function(){
      // }});
      
      TweenMax.fromTo(content,0.5,{opacity:0},{opacity:1,ease:Power1.easeOut, onComplete:function(){
      }});


      if(resetOthers) {
        $('article.block .info').addClass('hidden');
      }


    }

  });  

})(window, document, jQuery);
